import { FC } from 'react';

export const TipRow: FC = ({ children }) => {
  return <div className="tip-container__tr">{children}</div>;
};
